import type { AxiosResponse } from "axios";
import { Response } from "interfaces/utils/utils.interface";
import httpService from "plugins/axios";
import { logService } from "./log.service";

class Services {
  public get(page: string, pageSize: string): Promise<AxiosResponse<Response>> {
    return httpService.get<Response>(`admin/certificate/all?page=${page}&pageSize=${pageSize}`);
  }

  public getById(id: string): Promise<AxiosResponse<Response>> {
    return httpService.get<Response>(`admin/certificate/${id}`);
  }
  public create(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_certificate");
    const formData = new FormData();
    formData.append("cerFile", data.file);
    formData.append("nameTh", data.nameTh);
    formData.append("nameEn", data.nameEn);
    formData.append("detailTh", data.detailTh);
    formData.append("detailEn", data.detailEn);
    formData.append("isActive", data.isActive);
    return httpService.post<Response>(`admin/certificate`, formData);
  }
  public update(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_certificate");
    const formData = new FormData();
    formData.append("cerFile", data.file);
    formData.append("nameTh", data.nameTh);
    formData.append("nameEn", data.nameEn);
    formData.append("detailTh", data.detailTh);
    formData.append("detailEn", data.detailEn);
    formData.append("isActive", data.isActive);
    return httpService.patch<Response>(`admin/certificate/${data.id}`, formData);
  }
  public updateActive(data: any): Promise<AxiosResponse<Response>> {
    logService.create("manage_certificate");
    return httpService.patch<Response>(`admin/certificate/active/${data.id}`, {
      isActive: data.isActive,
    });
  }
  public delete(id: string): Promise<AxiosResponse<Response>> {
    logService.create("manage_certificate");
    return httpService.delete<Response>(`admin/certificate/${id}`);
  }
}

export const certificateService = new Services();
